import MutationDialog from './MutationDialog';

export default MutationDialog;
